'use client';
import { useEffect, useState } from 'react';

// Define Types for the Meta SDK
declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: any;
  }
}

export default function Home() {
  const [status, setStatus] = useState<string>('Loading SDK...');
  const [isSdkLoaded, setIsSdkLoaded] = useState<boolean>(false);

  // --- YOUR IDS ---
  const FACEBOOK_APP_ID = '1918061899084364'; 
  const CONFIG_ID = '1240446284685024'; // <--- PASTE YOUR CONFIG ID HERE (The one starting with 4, 5, or 6)

  useEffect(() => {
    window.fbAsyncInit = function() {
      window.FB.init({
        appId      : FACEBOOK_APP_ID,
        cookie     : true,
        xfbml      : true,
        version    : 'v18.0'
      });
      setStatus('SDK Ready');
      setIsSdkLoaded(true);
    };

    const d = document;
    const s = 'script';
    const id = 'facebook-jssdk';
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    const js = d.createElement(s) as HTMLScriptElement;
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    if (fjs && fjs.parentNode) {
      fjs.parentNode.insertBefore(js, fjs);
    }
  }, []);

  const launchWhatsAppSignup = () => {
    if (!window.FB) return;

    window.FB.login(function(response: any) {
      if (response.authResponse) {
        const code = response.authResponse.code;
        console.log('✅ Received Auth Code:', code);
        setStatus('Exchanging code...');

        // ---------------------------------------------------------
        // THIS IS THE PART YOU WERE MISSING (The Bridge to Backend)
        // ---------------------------------------------------------
        fetch('/api/exchange-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code: code })
        })
        .then(res => res.json())
        .then(data => {
          console.log('Backend Response:', data); // <--- Watch for this in console
          if(data.success) {
            setStatus('✅ Setup Complete! Token Saved.');
          } else {
            setStatus('❌ Error: ' + (data.error || 'Unknown Backend Error'));
          }
        })
        .catch(err => {
           console.error('Fetch Error:', err);
           setStatus('❌ Network Error (Check Nginx/Docker)');
        });

      } else {
        setStatus('Cancelled');
      }
    }, {
      config_id: CONFIG_ID,
      response_type: 'code',
      override_default_response_type: true,
      extras: { setup: {} }
    });
  };

  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-24 bg-slate-900 text-white">
      <div className="z-10 max-w-5xl w-full items-center justify-between font-mono text-sm lg:flex">
        <p className="fixed left-0 top-0 flex w-full justify-center border-b border-gray-300 bg-zinc-200 pb-6 pt-8 backdrop-blur-2xl dark:border-neutral-800 dark:bg-zinc-800/30 lg:static lg:w-auto lg:rounded-xl lg:border lg:bg-gray-200 lg:p-4">
          Status: {status}
        </p>
      </div>

      <div className="mt-10 text-center">
        <h1 className="text-4xl font-bold mb-6">WhatsApp SaaS Middleware</h1>
        <button 
          onClick={launchWhatsAppSignup}
          disabled={!isSdkLoaded}
          className={`font-bold py-4 px-8 rounded-full text-xl transition-all flex items-center gap-3 mx-auto 
            ${isSdkLoaded ? 'bg-[#25D366] hover:bg-[#128C7E] text-white' : 'bg-gray-600 text-gray-400'}`}
        >
          Connect WhatsApp
        </button>
      </div>
    </main>
  );
}
